import env from '@/env.js'
import getAlovaInstanceWithAuth from '@/helpers/getAlovaInstanceWithAuth'

const BASE_URL = `${env('API_BASE_URL')}/ms-notifications`
const alovaInstance = getAlovaInstanceWithAuth(BASE_URL)

export default {
  getSettings: () => {
    return alovaInstance.Get('/auth/settings', {
      name: 'getSettings',
      hitSource: undefined,
      // No memory cache: print_settings.food_apps can change from the Partners page
      localCache: null
    })
  },
  patchFoodAppPrintSetting: (source, data) => {
    return alovaInstance.Patch(`auth/settings/print-settings/food-apps/${source}`, data, {
      name: 'patchFoodAppPrintSetting'
    })
  }
}
